export const shortHash = (hash: string): string => hash.slice(0, 7);

export const short12Hash = (hash: string): string => hash.slice(0, 12);

export const hashCompare = (hash1: string, hash2: string): boolean =>
  shortHash(hash1) === shortHash(hash2);
